import React from "react";
import { Tag } from "antd";

export const CertifyStatus = {
    Certified: 'Certified',
    PendingCertification: 'Pending Certification',
    Uncertified: 'Uncertified',
    Rejected: 'Rejected',
}

export const UtilityCertifyStatusOptions = [
    {
        label: CertifyStatus.Certified,
        value: CertifyStatus.Certified,
    },
    {
        label: CertifyStatus.Uncertified,
        value: CertifyStatus.Uncertified,
    },
];

const CertifyStatusTag = ({ status }) => {
    if(!status) {
        return null
    }
    return <Tag color={status === CertifyStatus.Certified ? 'green' : status === CertifyStatus.PendingCertification ? 'orange' : status === CertifyStatus.Uncertified ? 'gray' : 'red'}>{status}</Tag>
}

export default CertifyStatusTag;
